<template>
  <div class="cpt-message-item">
    <img class="user-avatar" v-src="message.avatar" />
    <div class="user-nickname">{{ message.nickname }}</div>
    <div class="message-content">:{{ message.content }}</div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      default: () => {},
      type: Object,
    },
  },
};
</script>

<style lang="less">
.cpt-message-item {
  height: 28px;
  margin-bottom: 4px;
  padding: 6px 12px 6px 6px;
  display: flex;
  align-items: center;
  border-radius: 14px;
  background: #121316;
  max-width: 220px;
  width: fit-content;
  .user-avatar {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: 6px;
  }
  .user-nickname {
    color: #d2d3d7;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    max-width: 72px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .message-content {
    color: #d2d3d7;
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
